export default "__VITE_ASSET__7c0882eb__"